export const UserHotelBookingData = [
  {
    key: "1",
    id: "#HB-1245",
    hotelimage:"assets/img/hotels/hotel-01.jpg",
    hotelname: "Hotel Athenee",
    location:"Barcelona",
    room:"Suite Room",
    members:"2 Adults, 1 Child",
    day:"4 Days, 3 Nights",
    pricing:"$11,569",
    bookedOn:"15 May 2025",
    status:"Upcoming",
    action:"upcoming",
  },
  {
    key: "2",
    id: "#HB-3215",
    hotelimage:"assets/img/hotels/hotel-18.jpg",
    hotelname: "The Luxe Haven",
    location:"London",
    room:"Queen Room",
    members:"2 Adults, 2 Child",
    day:"3 Days, 2 Nights",
    pricing:"$10,745",
    bookedOn:"20 May 2025",
    status:"Upcoming",
    action:"upcoming",
  },
  {
    key: "3",
    id: "#HB-4581",
    hotelimage:"assets/img/hotels/hotel-19.jpg",
    hotelname: "The Urban Retreat",
    location:"Edinburgh",
    room:"Single Room",
    members:"2 Adults, 1 Child",
    day:"2 Days, 1 Night",
    pricing:"$8,160",
    bookedOn:"04 Jun 2025",
    status:"Upcoming",
    action:"upcoming",
  },
  {
    key: "4",
    id: "#HB-6545",
    hotelimage:"assets/img/hotels/hotel-20.jpg",
    hotelname: "The Grand Horizon",
    location:"Manchester",
    room:"Balcony View",
    members:"3 Adults, 2 Child",
    day:"5 Days, 4 Nights",
    pricing:"$14,840",
    bookedOn:"17 Jun 2025",
    status:"Pending",
    action:"pending",
  },
  {
    key: "5",
    id: "#HB-3256",
    hotelimage:"assets/img/hotels/hotel-21.jpg",
    hotelname: "Hotel Serene Valley",
    location:"Chelsea",
    room:"City View",
    members:"2 Adults, 2 Child",
    day:"3 Days, 2 Nights",
    pricing:"$10,450",
    bookedOn:"25 Jun 2025",
    status:"Upcoming",
    action:"upcoming",
  },
  {
    key: "6",
    id: "#HB-3654",
    hotelimage:"assets/img/hotels/hotel-22.jpg",
    hotelname: "Hotel Evergreen",
    location:"Las Vegas",
    room:"Suite Room",
    members:"2 Adults, 1 Child",
    day:"4 Days, 3 Nights",
    pricing:"$12,600",
    bookedOn:"02 Jul 2025",
    status:"Cancelled",
    action:"cancelled",
  },
 
  {
    key: "7",
    id: "#HB-1458",
    hotelimage:"assets/img/hotels/hotel-05.jpg",
    hotelname: "Stardust Hotel",
    location:"Salford",
    room:"Suite Room",
    members:"2 Adults, 2 Child",
    day:"2 Days, 1 Night",
    pricing:"$9,380",
    bookedOn:"12 Jul 2025",
    status:"Completed",
    action:"completed",
  },
  {
    key: "8",
    id: "#HB-6589",
    hotelimage:"assets/img/hotels/hotel-23.jpg",
    hotelname: "Hotel Plaza",
    location:"Newyork",
    room:"Single Room",
    members:"1 Adult, 1 Child",
    day:"3 Days, 2 Nights",
    pricing:"$10,400",
    bookedOn:"26 Jul 2025",
    status:"Completed",
    action:"completed",
  },
  {
    key: "9",
    id: "#HB-2315",
    hotelimage:"assets/img/hotels/hotel-13.jpg",
    hotelname: "Hotel Skyline Vista",
    location:"Cambridge",
    room:"Queen Room",
    members:"2 Adults, 1 Child",
    day:"4 Days, 3 Nights",
    pricing:"$12,810",
    bookedOn:"10 Aug 2025",
    status:"Completed",
    action:"completed",
  },
  {
    key: "10",
    id: "#HB-5414",
    hotelimage:"assets/img/hotels/hotel-24.jpg",
    hotelname: "Hotel Aurora Bliss",
    location:"Bristol",
    room:"Suite Room",
    members:"2 Adults, 1 Child",
    day:"5 Days, 4 Nights",
    pricing:"$15,450",
    bookedOn:"22 Aug 2025",
    status:"Completed",
    action:"completed",
  },
 

];
